import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { NavLink, useLocation } from "react-router-dom";
import { AnimatePresence, motion, useReducedMotion } from "motion/react";
import { assets, navigation } from "../content/siteContent";

export function SiteHeader() {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const reduceMotion = useReducedMotion();

  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 18);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.classList.toggle("nav-open", isOpen);
    return () => document.body.classList.remove("nav-open");
  }, [isOpen]);

  return (
    <header className={`site-header${isScrolled ? " is-scrolled" : ""}`}>
      <div className="header-inner">
        <NavLink className="brand" to="/" aria-label="ΑΣΟ Ωμέγα — Αρχική" data-target>
          <img src={assets.logo} alt="Λογότυπο ΑΣΟ Ωμέγα" />
        </NavLink>

        <nav className="desktop-nav" aria-label="Κύρια πλοήγηση">
          {navigation.map((item) => (
            <NavLink
              key={item.path}
              className={({ isActive }) => (isActive ? "nav-link is-active" : "nav-link")}
              to={item.path}
              data-target
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <NavLink className="button button--outline header-cta" to="/epikoinonia" data-target>
          Επικοινωνήστε μαζί μας
        </NavLink>

        <button
          className="menu-button"
          type="button"
          aria-label={isOpen ? "Κλείσιμο μενού" : "Άνοιγμα μενού"}
          aria-expanded={isOpen}
          aria-controls="mobile-navigation"
          onClick={() => setIsOpen((value) => !value)}
          data-target
        >
          {isOpen ? <X aria-hidden="true" /> : <Menu aria-hidden="true" />}
        </button>
      </div>

      <AnimatePresence>
        {isOpen ? (
          <motion.nav
            id="mobile-navigation"
            className="mobile-nav"
            aria-label="Πλοήγηση κινητού"
            initial={reduceMotion ? false : { opacity: 0, y: -12 }}
            animate={{ opacity: 1, y: 0 }}
            exit={reduceMotion ? undefined : { opacity: 0, y: -8 }}
            transition={{ duration: 0.24 }}
          >
            {navigation.map((item) => (
              <NavLink
                key={item.path}
                className={({ isActive }) => (isActive ? "mobile-nav-link is-active" : "mobile-nav-link")}
                to={item.path}
              >
                {item.label}
              </NavLink>
            ))}
          </motion.nav>
        ) : null}
      </AnimatePresence>
    </header>
  );
}
